import { ComponentRef } from '@angular/core';

export class AbcCoreComponent {
  componentRef: ComponentRef<unknown>;
  domElement: HTMLElement;

  constructor(componentRef: ComponentRef<unknown>, domElement: HTMLElement) {
    this.componentRef = componentRef;
    this.domElement = domElement;
  }
}
